import React, {Fragment} from "react";
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";

import Button from "@mui/material/Button";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";

import {
  setWizardActiveStep,
  setWizardSelectedValues,
  setWizardShowFeatureSection
} from "../../../../../actions/wizardFunctions";
import {getCurrentGroups, getCurrentWizardNavItems} from "./lookWizardFunctions";
import LookWizardContentFinalPrice from "./lookWizardContentFinalPrice";
import GroheWizardCompletedButtons from "../../../grohe/groheNavigation/groheWizard/groheWizardCompletedButtons";
import {IS_PRODUCT_JOURNEY} from "../../../../../config";
import GroheMobileFooterFiltersButton from "../../../grohe/groheMobile/groheMobileFooterFiltersButton";
import GroheMobileFooterViewButton from "../../../grohe/groheMobile/groheMobileFooterViewButton";
import WithUpdateLookCartItem from "../../../hocs/withUpdateLookCartItem";

const LookWizardContentButtons = (props) => {

  const {wizardActiveItem, wizardActiveStep, setWizardActiveStep, wizardSelectedValues, setWizardSelectedValues,
    isMobile, intl, filterGroups, wizardShowFeatureSection, setWizardShowFeatureSection,
    groheActiveFeatureQuantity} = props;

  if (!wizardActiveItem) {
    return null
  }

  const currentGroups = getCurrentGroups(wizardActiveItem, wizardActiveStep, wizardSelectedValues);
  const wizardGroup = currentGroups[0];

  const onSkipClick = () => {
    // const featureGroup = getFeatureGroupFromWizardGroup(wizardGroup);
    // if (featureGroup && featureGroup.activeFeature) {
    //   disableFeature(featureGroup.activeFeature, updateLookCartItem);
    //   updateCanvasCount();
    // }
    setWizardSelectedValues({
      [wizardActiveStep]: {
        wizardGroup,
      }
    });
    setWizardActiveStep(wizardActiveStep + 1);
  }

  const startAgain = () => {
    setWizardSelectedValues({}, true);
    setWizardActiveStep(0);
  }

  const previousClick = () => {
    // const newValues = Object.assign({}, wizardSelectedValues);
    // delete newValues[wizardActiveStep];
    // delete newValues[wizardActiveStep - 1];
    // setWizardSelectedValues(newValues, true);
    setWizardActiveStep(wizardActiveStep - 1)
  }

  const nextClick = () => {
    if (!wizardSelectedValues[wizardActiveStep]) {
      onSkipClick();
    } else {
      if (IS_PRODUCT_JOURNEY) {
        setWizardSelectedValues({
          [wizardActiveStep]: {
            ...(wizardSelectedValues[wizardActiveStep] || {}),
            quantity: groheActiveFeatureQuantity,
          }
        });
      }
      setWizardActiveStep(wizardActiveStep + 1);
    }
  }

  const returnClick = () => {
    setWizardShowFeatureSection(false);
  }

  // const closeWizardClick = () => {
  //   Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookWizardCompletedClose);
  //   history.push(getLookIdUrl());
  // };

  const skipEnabled = wizardActiveStep > -1 && currentGroups.length === 1 && wizardGroup.notRequired;
  const isCompletedStep = wizardActiveStep > -1 && !currentGroups.length;

  let nextDisabled = !wizardSelectedValues[wizardActiveStep];
  if (nextDisabled && currentGroups.length === 1 && wizardGroup.nodeType === "group") {
    const navItems = getCurrentWizardNavItems(wizardSelectedValues, wizardActiveStep, wizardActiveItem, wizardGroup, null, filterGroups);
    nextDisabled = !!navItems.length;
  }

  if (isMobile) {

    if (IS_PRODUCT_JOURNEY) {

      if (wizardActiveStep === -1) {
        return (
          <Button className={"look-button look-button--secondary look-button--no-radius look-button--no-padding look-button--grohe-active"}
                  onClick={() => setWizardActiveStep(0)}>
            <FormattedMessage id="wizard.start.button" values={{wizardName: wizardActiveItem.name}}/>
          </Button>
        )
      }

      if (isCompletedStep) {
        return <GroheWizardCompletedButtons/>
      }

      return (
        <Fragment>
          {isCompletedStep || currentGroups.length > 1 ? null : (
            <Fragment>
              <GroheMobileFooterFiltersButton/>
              <GroheMobileFooterViewButton/>
            </Fragment>
          )}
          <Button className={"look-button look-button--secondary look-button--no-radius look-button--no-padding"}
                  startIcon={<ChevronLeftIcon/>}
                  onClick={wizardShowFeatureSection ? returnClick : previousClick}>
            <FormattedMessage id={wizardShowFeatureSection ? "buttons.back" : "buttons.previous"}/>
          </Button>
          {wizardShowFeatureSection ? null : (
            <Fragment>
              {skipEnabled ? (
                <Button className={"look-button look-button--secondary look-button--no-radius look-button--no-padding look-button--64"}
                        onClick={onSkipClick}>
                  <FormattedMessage id="buttons.skip"/>
                </Button>
              ) : null}
              <Button className={"look-button look-button--secondary look-button--no-radius look-button--no-padding"
                + (!nextDisabled ? " look-button--grohe-active" : "")}
                      disabled={nextDisabled}
                      endIcon={<ChevronRightIcon/>}
                      onClick={nextClick}>
                <FormattedMessage id="buttons.next"/>
              </Button>
            </Fragment>
          )}
        </Fragment>
      )
    }

    return (
      <div className="lm-section__footer">
        {(wizardActiveStep > -1 && currentGroups.length) ? (
          <Fragment>
            <div className="lm-section__footer-button">
              <IconButton aria-label={intl.formatMessage({id:"buttons.previous"})}
                          className={"look-icon look-icon--small"}
                          onClick={previousClick}>
                <ChevronLeftIcon/>
              </IconButton>
              <span className="lm-header__title" onClick={previousClick}>
                <FormattedMessage id="buttons.previous"/>
              </span>
            </div>
            {skipEnabled ? (
              <div className="lm-section__footer-button">
                <span className="look-link" onClick={onSkipClick}>
                  <FormattedMessage id="buttons.skip"/>
                </span>
              </div>
            ) : null}
            <div className="lm-section__footer-button">
              <span className={"lm-section__footer-button-text" + (nextDisabled ? " lm-section__footer-button-text--disabled" : "")}
                    onClick={nextClick}>
                <FormattedMessage id="buttons.next"/>
              </span>
              <IconButton aria-label={intl.formatMessage({id:"buttons.next"})}
                          className="look-icon look-icon--small"
                          disabled={nextDisabled}
                          onClick={nextClick}>
                <ChevronRightIcon/>
              </IconButton>
            </div>
          </Fragment>
        ) : null}
      </div>
    )
  }

  return (
    <Fragment>
      <div className={isCompletedStep && IS_PRODUCT_JOURNEY ? "" : "lw-content__buttons"}>
        {(wizardActiveStep === -1) ? (
          <Button className={"look-button look-button--secondary"}
                  onClick={() => setWizardActiveStep(0)}>
            <FormattedMessage id="wizard.start.button" values={{wizardName: wizardActiveItem.name}}/>
          </Button>
        ) : null}
        {(wizardActiveStep > -1 && currentGroups.length) ? (
          <Fragment>
            <Button className={"look-button look-button--secondary look-button--no-transform"}
                    onClick={previousClick}>
              <FormattedMessage id="buttons.previous"/>
            </Button>
            <Button className={"look-button look-button--secondary look-button--no-transform"}
                    disabled={nextDisabled}
                    onClick={nextClick}>
              <FormattedMessage id="buttons.next"/>
            </Button>
          </Fragment>
        ) : null}
        {isCompletedStep && IS_PRODUCT_JOURNEY ? (
          <GroheWizardCompletedButtons/>
        ) : null}
        {isCompletedStep && !IS_PRODUCT_JOURNEY ? (
          <Button className={"look-button look-button--secondary"} onClick={startAgain}>
            <FormattedMessage id="shoppingCart.checkoutButtonStartOver" values={{wizardName: wizardActiveItem.name}}/>
          </Button>
        ) : null}
      </div>
      <div className={"lw-content__skip" + (isCompletedStep ? IS_PRODUCT_JOURNEY ? " lw-content__skip--product" : " text-center" : "")}>
        {skipEnabled ? (
          <span className="look-link" onClick={onSkipClick}>
            <FormattedMessage id="buttons.skip"/>
            <ChevronRightIcon/>
          </span>
        ) : null}
        {isCompletedStep && IS_PRODUCT_JOURNEY ? <LookWizardContentFinalPrice/> : null}
        {/*{isCompletedStep ? (*/}
        {/*  <span className="look-link" onClick={closeWizardClick}>*/}
        {/*    <FormattedMessage id="wizard.completed.close"/>*/}
        {/*  </span>*/}
        {/*) : null}*/}
      </div>
    </Fragment>
  )

};

const mapStateToProps = (store) => {
  // const {activePreset, bvPresets} = store.bathroomVisualizerState;
  const {wizardActiveItem, wizardActiveStep, wizardSelectedValues, wizardShowFeatureSection} = store.wizardState;
  const {isMobile} = store.serverState;
  const {filterGroups} = store.filterState;
  // const fabricatorData = store.fabricatorState;
  const {groheActiveFeatureQuantity} = store.groheState;

  return {
    // activePreset,
    // bvPresets,
    wizardActiveItem,
    wizardActiveStep,
    wizardSelectedValues,
    isMobile,
    filterGroups,
    wizardShowFeatureSection,
    // fabricatorData,
    groheActiveFeatureQuantity,
  };
};

const mapDispatchToProps = {
  setWizardActiveStep,
  setWizardSelectedValues,
  setWizardShowFeatureSection
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)((props) => {
    return (
      <WithUpdateLookCartItem>
        {(updateLookCartItem) => <LookWizardContentButtons {...props} updateLookCartItem={updateLookCartItem}/>}
      </WithUpdateLookCartItem>
    )
  })
)
